import React from "react";
import { useLang } from "@/context/LangContext";
import { Globe } from "@phosphor-icons/react";

export default function LangSwitch() {
  const { lang, toggleLang } = useLang();
  return (
    <button onClick={toggleLang} data-testid="lang-switch"
      className="flex items-center gap-1.5 text-slate-400 hover:text-white transition-colors text-sm border border-slate-700 px-2.5 py-1.5 rounded-lg hover:bg-slate-800"
      title={lang === "en" ? "Switch to Arabic" : "التبديل إلى الإنجليزية"}>
      <Globe size={16} />
      <span className="font-['Outfit'] text-xs font-semibold">{lang === "en" ? "عربي" : "EN"}</span>
    </button>
  );
}
